import 'whatwg-fetch';
import 'babel-polyfill';
import 'intersection-observer';
import 'element.scrollintoviewifneeded-polyfill';
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from '@material-ui/core/styles';
import ErrorBoundary from 'JS/shared/components/ErrorBoundaryView';

import App from './App';
import localiser from './shared/resources/localiser';
import { getStore, initializeStore } from './store';
import { BASE_PATH } from './config/routes';
import config from './config/config';
import { getHistory } from './store/middlewares/routes';
import initSentry from './logging';
import theme from './theme';

import './shims/ios.js';
import './shared/helpers/get-user-media.js';

import '../css/main.css';
import '../assetlinks/assetlinks.json';

initSentry(config.SENTRY_DSN, config.SENTRY_RELEASE, config.SENTRY_ENVIRONMENT);

if (process.env.NODE_ENV !== 'production') {
  console.warn(`
    You are running this application in development or test mode.
    If you are seeing this message in production there was an issue with the environment settings on the build server.
  `);
}

const currentLocale = 'dev'; // TODO: from localStorage...
localiser.loadResourcesFor(currentLocale);

initializeStore();
class Index extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <Provider store={getStore()}>
            <ConnectedRouter history={getHistory()} basename={BASE_PATH}>
              <Route component={App} />
            </ConnectedRouter>
          </Provider>
        </ErrorBoundary>
      </ThemeProvider>
    );
  }
}

const rootEl = document.getElementById('root');

render(<Index />, rootEl);
